<template>
  <div class="container text-left">
    <div class="success" v-if="result === 'success'">
      <h1>Success</h1>
    </div>
    <div class="failure" v-if="result === 'failure'">
      <h1>Failure</h1>
    </div>
    <div class="row">
      <div class="col">
        <h1>
          {{ student.name }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h2>
          {{ student.email }}
        </h2>
      </div>
    </div>

    <div class="row pb-3 container" v-for="q in questions" :key="q.order">
      <div class="col col-11">
        {{ q.text }}
      </div>
      <div class="col">
        <span :class="{'yes': doc.answers[q.name] === 'Yes', 'no': doc.answers[q.name] === 'No'}">{{ doc.answers[q.name] }}</span>
      </div>
    </div>

    <div class="row pb-3 container">
      <div class="col">
        <div class="form-group">
          <label for="comments">Administrator Comments</label>
          <textarea type="email" class="form-control" id="comments" rows="3" v-model="comments" aria-describedby="commentsHelp">
          </textarea>
        </div>
        <button type="button" class="btn btn-primary" @click="override">Override</button>
      </div>
    </div>
  </div>
</template>

<script>
const firebase = require("firebase");
// Required for side-effects
require("firebase/firestore");

export default {
  methods: {
    override () {
      var override = {
        override: true,
        comments: this.comments
      }
      var db = firebase.firestore()
      console.log(this.$route.params.survey)
      var doc = db.doc(`surveys/${this.$route.params.survey}`)
      var vm = this
      doc.update(override)
      .then(() => {
        vm.result='success'
      })
      .catch(() => {
        vm.result='failure'
      })
    }
  },
  data () {
    return {
      user: null,
      doc: null,
      student: null,
      comments: '',
      result: null,
      questions: [
        {
          order: 1,
          name: "cough",
          text: "Within the last 14-days, have you experienced a new cough that you cannot attribute to another health condition?",
          response: null
        },
        {
          order: 2,
          name: "shortness",
          text: "Within the last 14-days, have you experienced new shortness of breath that you cannot attribute to another health condition?",
          response: null
        },
        {
          order: 3,
          name: "throat",
          text: "Within the last 14-days, have you experienced a new sore throat that you cannot attribute to another health condition?",
          response: null
        },
        {
          order: 4,
          name: "aches",
          text: "Within the last 14-days, have you experienced new muscle aches that you cannot attribute to another health condition or a specific activity such as physical exercise?",
          response: null
        },
        {
          order: 5,
          name: "temperature",
          text: "Within the last 14-days, have you had a temperature at or above 100.4° or the sense of having a fever?",
          response: null
        },
        {
          order: 6,
          name: "contact", 
          text: "Within the last 14 days, have you had close contact, without the use of appropriate PPE, with someone who is currently sick with suspected or confirmed COVID-19?* (Note: Close contact is defined as within 6 feet for more than 15 consecutive minutes)",
          response: null
        }
      ]
    }
  },
  computed: {
    survey () {
      return this.$route.params.survey
    }
  },
  mounted () {
    if (!firebase.apps.length) {
      firebase.initializeApp({
        apiKey: 'AIzaSyCbB-7CihyBpgzM7p_vmKeA2QQOcmBEH2M',
        authDomain: 'bldg-screen.firebaseapp.com',
        projectId: 'bldg-screen'
      });
    }

    var provider = new firebase.auth.GoogleAuthProvider();
    provider.setCustomParameters({
      'prompt': 'select_account'
    });
    provider.addScope('profile');
    provider.addScope('email');

    var u = firebase.auth().currentUser
    var db = firebase.firestore()
    // console.log('USER MOUNTED', u)

    if (!u) {
      const vm = this
      firebase.auth().getRedirectResult().then(function(result) {
        // if (result.credential) {
        //   // This gives you a Google Access Token. You can use it to access the Google API.
        //   var token = result.credential.accessToken;
        //   // ...
        // }
        // The signed-in user info.
        var user = result.user;

        if (!user) {
          firebase.auth().signInWithRedirect(provider)
        }
        // console.log('USER REDIRECT', user.email, user.displayName, user, token)

        if (!['suscc.edu'].includes(user.email.split("@")[1])) {
          throw new Error("Must log in with Southern Union email")
        }

        vm.user = user

      }).catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // The email of the user's account used.
        var email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        var credential = error.credential;
        // ...
        console.error("ERROR", errorCode, errorMessage, email, credential)
      })

      
    } else {
      this.user = u
    }

    if (this.user) {
      // first check for admin status
      console.log("CHECKING FOR ADMIN", this.user.email)
      let uprofileq = db.collection('profiles').where('email', '==', this.user.email)
      var uprofile = null
      uprofileq.get().then(qs => {
        console.log("FETCHING PROFILE")
        if (qs.docs.length > 0) {
          console.log("FOUND PROFILE")
          uprofile = qs.docs[0].data()
          console.log("UPROFILE", uprofile)
          if (uprofile.traits.indexOf('admin') === -1) {
            firebase.auth().signOut()
            firebase.auth().signInWithRedirect(provider)
          } else {
            console.log("IS ADMIN")
          }
        } else {
          console.log("NO PROFILE FOUND")
          firebase.auth().signOut()
          firebase.auth().signInWithRedirect(provider)
        }
      })
      
      // is admin, so 
      var doc = db.doc(`surveys/${this.$route.params.survey}`)
      const vm = this
      doc.get().then(d => {
        if(d.exists) {
          vm.doc = d.data()
          let profiles = db.collection('profiles').where('email', '==', vm.doc.email)
          profiles.get().then(qs => {
            if (qs.docs.length > 0) {
              vm.student = qs.docs[0].data()
            }
          })
        } else {
          console.error("No such document")
        }
      })
    }
  }

}
</script>

<style scoped>
.yes {
  color: red;
}

.no {
  color: green;
}

.success, .failure {
  text-align: center;
  z-index: 100;
  margin: auto;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(224, 224, 224, 0.9)
}

.success h1, .failure h1 {
  position: fixed;
  display: inline-block;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.success {
  color: green;
}

.failure {
  color: red;
}
</style>
